import {
    whatsNew_Card_LinkedInBind_Body,
    whatsNew_Card_LinkedInBind_Connect,
    whatsNew_Card_LinkedInBind_Connected,
    whatsNew_Card_LinkedInBind_Title,
} from '../../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Label } from 'office-ui-fabric-react/lib/Label';

import { connectToLinkedInLazy } from 'owa-linkedin';
import { logWhatsNewCardShown, logWhatsNewCardButtonClicked } from '../../utils/logDatapoint';
import { WhatsNewCardIdentity } from '../../store/schema/WhatsNewCardIdentity';
import { isUnbound } from 'owa-linkedin';
import { ControlIcons } from 'owa-control-icons';
import { WhatsNewCardProperty } from '../../store/schema/WhatsNewCardProperty';
import { resolve as urlResolve } from 'url';
import { getPackageBaseUrl } from 'owa-config';
import { initializeBindStatusLazy } from 'owa-linkedin';

const styles = require('../WhatsNewFluentCard.scss');

function onLinkedInBindClicked(evt: React.MouseEvent<unknown>) {
    evt.stopPropagation();
    logWhatsNewCardButtonClicked(WhatsNewCardIdentity.ConnectToLinkedIn);
    connectToLinkedInLazy.importAndExecute();
}

export const LinkedInBindCard = observer(function LinkedInBindCard(props: {}) {
    React.useEffect(() => {
        logWhatsNewCardShown(WhatsNewCardIdentity.ConnectToLinkedIn);
    }, []);

    return (
        <div>
            <div>{loc(whatsNew_Card_LinkedInBind_Body)}</div>
            {isUnbound() ? (
                <Link onClick={onLinkedInBindClicked} className={styles.whatsNewCardCallToAction}>
                    {loc(whatsNew_Card_LinkedInBind_Connect)}
                </Link>
            ) : (
                <Label className={styles.whatsNewCardCallToAction}>
                    {loc(whatsNew_Card_LinkedInBind_Connected)}
                </Label>
            )}
        </div>
    );
});

function linkedInBindCardProps(): WhatsNewCardProperty {
    return {
        identity: WhatsNewCardIdentity.ConnectToLinkedIn,
        title: loc(whatsNew_Card_LinkedInBind_Title),
        iconName: ControlIcons.LinkedInLogo,
        body: <LinkedInBindCard />,
        animation: (
            <img
                className={styles.whatsNewCardAnimation}
                src={urlResolve(
                    getPackageBaseUrl(),
                    'resources/images/WhatsNew_LinkedIn_sized.gif'
                )}
            />
        ),
        isHidden: async () => {
            await initializeBindStatusLazy.importAndExecute();
            return !isUnbound();
        },
    };
}

export default linkedInBindCardProps;
